<div class="landing-page">
  <div class="click-area-left" (click)="navigateToGrid(gridTypes.monochrome)">
    <div class="area-title">monochrom</div>
  </div>
  <div class="click-area-right" (click)="navigateToGrid(gridTypes.color)">
    <div class="area-title">farbe</div>
  </div>
</div>
